import React from 'react';
const TotalSum = props => {
	return (
		<section className="TotalSum">
			<div>Summa: {props.transactions.reduce((a, b) => a + (b.sum || 0), 0).toFixed(2)} €</div>
		</section>
	);
};
export default TotalSum;
